
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"33","viewBox":"0 0 34 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.766 16.353c0-7.31 5.926-13.235 13.236-13.235 7.31 0 13.235 5.926 13.235 13.235 0 7.31-5.926 13.236-13.235 13.236a13.19 13.19 0 01-6.316-1.601l-5.212.969a.923.923 0 01-1.076-1.076l.97-5.212a13.174 13.174 0 01-1.602-6.316zm11.198-5.413c-.425.36-.732.908-.732 1.72a.923.923 0 01-1.847 0c0-1.344.538-2.411 1.384-3.128.825-.701 1.893-1.028 2.925-1.028 1.032 0 2.1.327 2.925 1.027.846.718 1.384 1.785 1.384 3.129 0 .943-.241 1.662-.636 2.253-.332.497-.762.881-1.101 1.184l-.107.096c-.38.34-.664.62-.873.99-.2.353-.36.847-.36 1.633a.923.923 0 01-1.848 0c0-1.062.223-1.877.601-2.543.368-.65.853-1.1 1.244-1.453l.088-.08c.37-.332.626-.56.82-.852.183-.273.325-.633.325-1.228 0-.812-.307-1.36-.732-1.72-.443-.377-1.069-.589-1.73-.589s-1.287.212-1.73.589zM17.7 24.357a.924.924 0 10-1.372-1.236l-.012.014a.924.924 0 001.372 1.236l.012-.014z","fill":"#fff"}})])
          )
        }
      }
    